import { gql } from '@apollo/client';

export const ReportAndBlockContentMutationName = 'ReportAndBlockContent';

export const REPORT_AND_BLOCK_CONTENT_MUTATION = gql`
  mutation ${ReportAndBlockContentMutationName}(
    $input: ReportAndBlockContentInput!
  ) {
    reportAndBlockContent(input: $input) {
      reportId
      blockedUserId
    }
  }
`;
